import React, { useRef } from 'react';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import styles from './Certificate.module.css';
import TpltImage from './Tplt.png';
import CorporateSeal from './CorporateSeal.png';
import LogoImage from './Logo-Transparent.png';
import { formatValue } from '../../../utils/formats';


function Certificate({
  shareholder,
  shareAmount,
  className,
  issuanceDate,
  pricePerShare,
  company,
}) {
  const frontRef = useRef();
  const backRef = useRef();

  const handleDownloadPDF = async () => {
    const pdf = new jsPDF('landscape', 'pt', 'a4');

    const capturePage = async (ref) => {
      const canvas = await html2canvas(ref.current, {
        scale: 2,
        useCORS: true,
      });
      const imgData = canvas.toDataURL('image/png');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const scaleFactor = pdfWidth / canvas.width;
      const verticalOffset = (pdfHeight - (canvas.height * scaleFactor)) / 2;

      return { imgData, scaleFactor, verticalOffset, canvas };
    };

    const front = await capturePage(frontRef);
    pdf.addImage(front.imgData, 'PNG', 0, front.verticalOffset, front.canvas.width * front.scaleFactor, front.canvas.height * front.scaleFactor);

    const back = await capturePage(backRef);
    pdf.addPage();
    pdf.addImage(back.imgData, 'PNG', 0, back.verticalOffset, back.canvas.width * back.scaleFactor, back.canvas.height * back.scaleFactor);

    pdf.save(`certificate-${shareholder}.pdf`);
  };

  return (
    <div>
      {/* FRONT PAGE */}
      <div ref={frontRef} style={{ position: 'relative', width: '1123px', height: '794px', backgroundImage: `url(${TpltImage})`, backgroundSize: 'cover', backgroundPosition: 'center', color: '#000', padding: '4rem', fontFamily: 'serif' }}>
        <div style={{ position: 'absolute', top: '180px', left: '20%', fontSize: '16px', fontWeight: 'bold' }}>
          Certificate <br />{className}
        </div>
        <div style={{ position: 'absolute', top: '180px', right: '20%', fontSize: '16px', fontWeight: 'bold' }}>
          Shares <br />{formatValue(shareAmount, 'number')}
        </div>
        <img src={LogoImage} alt="Company Logo" style={{ width: '100px', height: 'auto', position: 'absolute', top: '180px', left: '50%', transform: 'translateX(-50%)' }} />
        <div style={{ textAlign: 'center', position: 'absolute', top: '270px', left: '50%', transform: 'translateX(-50%)' }}>
          <h1 className={styles.canterbury} style={{ fontSize: '36px', marginBottom: '0.5rem' }}>{company}</h1>
          <p style={{ fontSize: '20px', margin: 0 }}>Stock Certificate</p>
          <div style={{ marginTop: '60px', textAlign: 'center', lineHeight: '1.6' }}>
            <p>This is to certify that</p>
            <h2 className={styles.canterbury} style={{ margin: '10px 0' }}>{shareholder}</h2>
            <p>
            was on <strong>{issuanceDate ? new Date(issuanceDate).toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                }) : '—'}</strong> the registered holder of
                <br />
                <strong>{formatValue(shareAmount, 'number')}</strong> shares of Founder Series stock, par ${parseFloat(pricePerShare).toFixed(2)}, each fully paid <br />
              in the above named company ({company}), subject to the Articles of Incorporation.
            </p>
          </div>
        </div>

        {/* Signatures */}
        <div style={{ position: 'absolute', bottom: '140px', left: '20%', textAlign: 'center', width: '25%' }}>
          <div style={{ position: 'relative' }}>
            <p className={styles.edwardian} style={{ fontSize: '36px', marginBottom: '0', position: 'absolute', bottom: '25px', width: '100%', textAlign: 'center', color: '#1A237E' }}>Larisa Mathur</p>
            <p style={{ margin: '0' }}>_________________________</p>
            <p style={{ marginTop: '5px' }}>Larisa Mathur CEO</p>
          </div>
        </div>
        <img src={CorporateSeal} alt="Corporate Seal" style={{ position: 'absolute', bottom: '175px', left: '50%', transform: 'translateX(-50%)', width: '100px', height: '100px', opacity: 0.9 }} />
        <div style={{ position: 'absolute', bottom: '140px', right: '20%', textAlign: 'center', width: '25%' }}>
          <div style={{ position: 'relative' }}>
            <p className={styles.edwardian} style={{ fontSize: '36px', marginBottom: '0', position: 'absolute', bottom: '25px', width: '100%', textAlign: 'center', color: '#1A237E' }}>Daniel Sirlin</p>
            <p style={{ margin: '0' }}>_________________________</p>
            <p style={{ marginTop: '5px' }}>Daniel Sirlin CFO</p>
          </div>
        </div>
      </div>

      {/* BACK PAGE */}
      <div ref={backRef} 
        style={{ position: 'relative', 
                width: '1123px', 
                height: '794px', 
                backgroundImage: `url(${TpltImage})`, 
                backgroundSize: 'cover', 
                backgroundPosition: 'center', 
                color: '#000', 
                padding: '4rem', 
                fontFamily: 'serif', 
                marginTop: '40px' }}>
        <p style={{ whiteSpace: 'pre-wrap', 
            fontSize: '16px', 
            lineHeight: '1.6', 
            textAlign: 'center', 
            padding: '6rem',  
            borderRadius: '10px',
            marginTop: '150px' }}>
          The securities evidenced by this certificate have not been registered under any security act or the securities laws of any state or other jurisdiction. The
          securities may not be offered, sold, pledged or otherwise transferred except pursuant to an exemption from registration under the relevant securities act or
          pursuant to an effective registration statement under the securities act, in each case in accordance with all applicable state or securities laws and the
          securities laws of other jurisdictions, and in the case of a transaction exempt from registration, unless the company has received an opinion of counsel
          reasonably satisfactory to it that such transaction does not require registration under the securities act and such other applicable laws.
          The securities represented hereby may be transferred only in accordance with the terms of an agreement between the company and the stockholder, a copy
          of which is on file with the Secretary of the Company.
        </p>
      </div>

      <div style={{ marginTop: '20px', textAlign: 'center' }}>
        <button onClick={handleDownloadPDF}>Download Certificate PDF</button>
      </div>
    </div>
  );
}

export default Certificate;
